import { getAppletsUrl } from './getAppletsUrl';
import { getHomepageUrl } from './getHomepageUrl';
import { getStudioUrl } from './getStudioUrl';
import {
  type NotificationSurface,
  parseLocation,
} from './notificationLocation';

function normalizePath(link: string): string {
  if (!link) {
    return '/';
  }
  return link.startsWith('/') ? link : `/${link}`;
}

function urlForSurface(surface: NotificationSurface, path: string): string {
  switch (surface) {
    case 'studio':
      return `${getStudioUrl()}${path}`;
    case 'apps':
      return `${getAppletsUrl()}${path}`;
    case 'homepage':
      return getHomepageUrl(path);
  }
}

/** Full URL for a notification CTA: absolute URL or `surface:/path` from the API. */
export function resolveNotificationLinkUrl(link: string): string {
  if (link.startsWith('http://') || link.startsWith('https://')) {
    return link;
  }

  const parsed = parseLocation(link);
  if (!parsed) {
    return `${getAppletsUrl()}${normalizePath(link)}`;
  }

  return urlForSurface(parsed.surface, parsed.pathname);
}
